import api from 'app/api';
import addTerminal from './add-terminal';
import deleteById from './delete-terminal';
import editTerminal from './edit-terminal';
import getTerminal from './get-terminal';
import getAllWithJoin from './get-terminals-with-join';
import getAll from './get-terminals';

export const terminalsApi = api.injectEndpoints({
    endpoints: (build) => ({
        getTerminals: getAll(build),
        getTerminalsWithJoin: getAllWithJoin(build),
        deleteTerminal: deleteById(build),
        getTerminal: getTerminal(build),
        addTerminal: addTerminal(build),
        editTerminal: editTerminal(build),
    }),
});

export const {
    useGetTerminalsQuery,
    useGetTerminalsWithJoinQuery,
    useDeleteTerminalMutation,
    useGetTerminalQuery,
    useAddTerminalMutation,
    useEditTerminalMutation,
} = terminalsApi;
